import { uuidv4 } from '@/utils'

const mutations = {
  updateInvoicesToken (state, val) {
    state.invoicesToken = val
  }
}

const getters = {
  invoicesToken (state) {
    return state.invoicesToken
  }
}

const actions = {
  async refreshInvoices ({ commit }) {
    commit('updateInvoicesToken', uuidv4())
  },
}

export default {
  state: {
    invoicesToken: ''
  },
  actions,
  getters,
  mutations
}
